import {
    activityToolTips as activityColumns,
    contactToolTips as contactColumns,
    growthAnalysisTooltips as growthAnalysisColumns,
    listingProficiencyTooltips as listingProficiencyColumns,
    overviewToolTips as overviewColumns,
    tableViewNames,
    tabModes
} from "../agent-production/constants/agentProductionConstants";
import {
    growthAnalysisColumnsL90d,
    growthAnalysisColumnsLtmIncDec,
    growthAnalysisColumnsYtdIncDec
} from "../common/components/table/agGrid/tableViews";

export const colProps = {
    [tabModes.OVERVIEW] : {
        allMlsColProps:                 { xs: 12, sm: 5, md: 5 },
        newProducerColProps:            { xs: 12, sm: 6, md: 6 },
        coopAgentsColProps:             { xs: 12, sm: 6, md: 4 },
        defaultOfficeInfoColProps:      { xs: 12, sm: 3, md: 3 },
        defaultCurrentPeriodColProps:   { xs: 12, sm: 4, md: 4 },
    },
    [tabModes.CONTACT_INFORMATION]: {
        newProducerColProps:            { xs: 12, sm: 6, md: 4, lg: 4 },
        defaultOfficeInfoColProps:      { xs: 12, sm: 6, md: 4, lg: 3 },
        defaultContactInfoColProps:     { xs: 12, sm: 6, md: 4, lg: 3 },
        defaultCurrentSearchColProps:   { xs: 12, sm: 6, md: 4, lg: 2 },
    },
    [tabModes.GROWTH_ANALYSIS]: {
        defaultColProps:                { xs: 12, sm: 12, md: 4 },
    },
    [tabModes.ACTIVITY]: {
        allMlsColProps:                 { xs: 12, sm: 5, md: 5 },
    },
    [tabModes.LISTING_PROFICIENCY]: {
        defaultColProps:                { xs: 12, sm: 4, md: 2, lg: 2 },
        officeInfoColProps:             { xs: 12, sm: 4, md: 3, lg: 2 },
        noPriceChangeColProps:          { xs: 12, sm: 4, md: 2, lg: 3 },
        priceChangeColProps:            { xs: 12, sm: 4, md: 3, lg: 3 },
    },
};

export const dataTestId = {
    currentPeriod: 'current-period',
    last12Months: 'last-12-months',
    noPriceChange: 'no-price-change',
    officeInfo: 'office-info',
    priceChange: 'price-change',
    recentCoopTransaction: 'recent-coop-transaction',
    totalSell: 'total-sell',
    totalList: 'total-list',
    units: 'units',
    volume: 'volume',
    activity: 'activity-csv-modal',
};

export const colGroups = {
    [tableViewNames.overview] : {
        getOfficeOptions: (isCoopAgents) => ([
            overviewColumns.agentId,
            overviewColumns.officeId,
            ...(isCoopAgents ? [overviewColumns.listingAddress] : [overviewColumns.officeAddress]),
        ]),
        currentTimePeriodOptions: [
            overviewColumns.listVolume,
            overviewColumns.sellVolume,
            overviewColumns.totalVolume,
            overviewColumns.listUnits,
            overviewColumns.sellUnits,
            overviewColumns.totalUnits,
        ],
        recentCoopTransactionOptions: [
            overviewColumns.listingClosedDate,
            overviewColumns.listingSalePrice,
            overviewColumns.coopSide,
            overviewColumns.totalVolume,
            overviewColumns.totalUnits,
            overviewColumns.myAgentName,
        ],
        getAllMlsOptions: (isIncDecOverview) => ([
            overviewColumns.averagePrice,
            overviewColumns.last12Spop,
            overviewColumns.last12AvgDom,
            ...(isIncDecOverview ? [overviewColumns.ltmTotalUnitsChange] : [overviewColumns.totalUnitsChange,]),
            ...(isIncDecOverview ? [overviewColumns.ltmTotalVolumeChange] : [overviewColumns.totalVolumeChange,]),
            overviewColumns.last12ListVolume,
            overviewColumns.last12SellVolume,
            overviewColumns.last12TotalVolume,
            overviewColumns.last12ListUnits,
            overviewColumns.last12SellUnits,
            overviewColumns.last12TotalUnits,
        ])
    },
    [tableViewNames.contactInformation]: {
        officeOptions: [
            contactColumns.agentId,
            contactColumns.officeId,
            contactColumns.officeAddress,
        ],
        contactInformationOptions: [
            contactColumns.agentPhoneType1,
            contactColumns.agentPhone1,
            contactColumns.agentPhoneType2,
            contactColumns.agentPhone2,
            contactColumns.agentPhoneType3,
            contactColumns.agentPhone3,
            contactColumns.agentEmail,
            contactColumns.agentAddress
        ],
        currentSearchOptions: [
            contactColumns.totalUnits,
            contactColumns.totalVolume
        ],
        allMlsOptions: [
            contactColumns.last12TotalUnits,
            contactColumns.last12TotalVolume
        ],
        growthOptions: [
            contactColumns.totalVolumeChange,
            contactColumns.totalVolumeGrowth
        ]
    },
    [tableViewNames.growthAnalysisL90]: {
        getOfficeOptions: () => ([
            growthAnalysisColumns.officeId,
            growthAnalysisColumns.officeAddress
        ]),
        getUnitOptions: () => ([
            growthAnalysisColumnsL90d.previousPeriodTotalUnits,
            growthAnalysisColumnsL90d.totalUnits,
            growthAnalysisColumnsL90d.totalUnitsChange,
            growthAnalysisColumnsL90d.totalUnitsGrowth,
        ]),
        getVolumeOptions: () => ([
            growthAnalysisColumnsL90d.previousPeriodTotalVolume,
            growthAnalysisColumnsL90d.totalVolume,
            growthAnalysisColumnsL90d.totalVolumeChange,
            growthAnalysisColumnsL90d.totalVolumeGrowth,
        ]),
    },
    [tableViewNames.growthAnalysisLtm]: {
        getOfficeOptions: () => ([
            growthAnalysisColumns.officeId,
            growthAnalysisColumns.officeAddress
        ]),
        getUnitOptions: (isIncDecGrowthAnalysis) => ([
            growthAnalysisColumns.ptmTotalUnits,
            growthAnalysisColumns.last12TotalUnits,
            ...(isIncDecGrowthAnalysis ? [growthAnalysisColumns.ltmTotalUnitsChange] : [growthAnalysisColumns.totalUnitsChange]),
            ...(isIncDecGrowthAnalysis ? [growthAnalysisColumns.ltmTotalUnitsGrowth] : [growthAnalysisColumns.totalUnitsGrowth]),
        ]),
        getVolumeOptions: (isIncDecGrowthAnalysis) => ([
            growthAnalysisColumns.ptmTotalVolume,
            growthAnalysisColumns.last12TotalVolume,
            {
                ...(isIncDecGrowthAnalysis ? growthAnalysisColumns.ltmTotalVolumeChange : growthAnalysisColumns.totalVolumeChange),
                tip: growthAnalysisColumns.totalVolumeChange.tip,
            },
            {
                ...(isIncDecGrowthAnalysis ? growthAnalysisColumns.ltmTotalVolumeGrowth : growthAnalysisColumns.totalVolumeGrowth),
                tip: growthAnalysisColumns.totalVolumeGrowth.tip,
            },
        ])
    },
    [tableViewNames.growthAnalysisYtd]: {
        getOfficeOptions: () => ([
            growthAnalysisColumns.officeId,
            growthAnalysisColumns.officeAddress
        ]),
        getUnitOptions: () => ([
            growthAnalysisColumns.pytdTotalUnits,
            growthAnalysisColumns.lytdTotalUnits,
            {
                ...growthAnalysisColumns.lytdPytdTotalUnitsChange,
                tip: growthAnalysisColumns.lytdPytdTotalUnitsChange.tip
            },
            {
                ...growthAnalysisColumns.lytdPytdTotalUnitsGrowth,
                tip: growthAnalysisColumns.lytdPytdTotalUnitsGrowth.tip
            }
        ]),
        getVolumeOptions: () => ([
            growthAnalysisColumns.pytdTotalVolume,
            growthAnalysisColumns.lytdTotalVolume,
            growthAnalysisColumns.lytdPytdTotalVolumeChange,
            growthAnalysisColumns.lytdPytdTotalVolumeGrowth,
        ]),
    },
    [tableViewNames.listingProficiency]: {
        officeOptions: [
            listingProficiencyColumns.officeId,
            listingProficiencyColumns.officeAddress
        ],
        totalSellOptions: [
            listingProficiencyColumns.last12SellUnits,
            listingProficiencyColumns.last12SellVolume,
        ],
        totalListOptions: [
            listingProficiencyColumns.last12ListUnits,
            listingProficiencyColumns.last12ListVolume,
        ],
        noPriceChangeOptions: [
            listingProficiencyColumns.noPcLast12ListUnits,
            listingProficiencyColumns.noPcLast12ListUnitsPct,
            listingProficiencyColumns.noPcLast12ListVolume,
            listingProficiencyColumns.noPcLast12ListVolumePct,
            listingProficiencyColumns.noPcLast12ListDom,
            listingProficiencyColumns.noPcLast12ListCdom,
            listingProficiencyColumns.noPcLast12SpOp
        ],
        priceChangeOptions: [
            listingProficiencyColumns.pcLast12ListUnits,
            listingProficiencyColumns.pcLast12ListUnitsPct,
            listingProficiencyColumns.pcLast12ListVolume,
            listingProficiencyColumns.pcLast12ListVolumePct,
            listingProficiencyColumns.pcLast12ListDom,
            listingProficiencyColumns.pcLast12ListCdom,
            listingProficiencyColumns.pcLast12ListPcDom,
            listingProficiencyColumns.pcLast12ListSpOp,
            listingProficiencyColumns.pcLast12ListSpLp,
            listingProficiencyColumns.pcLast12ListAvgNumPc
        ]
    },
    [tableViewNames.incDecGrowthAnalysisLtm]: {
        getOfficeOptions: () => ([
            growthAnalysisColumnsLtmIncDec.officeId,
            growthAnalysisColumnsLtmIncDec.officeAddress
        ]),
        getUnitOptions: () => ([
            growthAnalysisColumnsLtmIncDec.previousPeriodTotalUnits,
            growthAnalysisColumnsLtmIncDec.totalUnits,
            growthAnalysisColumnsLtmIncDec.totalUnitsChange,
            growthAnalysisColumnsLtmIncDec.totalUnitsGrowth
        ]),
        getVolumeOptions: () => ([
            growthAnalysisColumnsLtmIncDec.previousPeriodTotalVolume,
            growthAnalysisColumnsLtmIncDec.totalVolume,
            growthAnalysisColumnsLtmIncDec.totalVolumeChange,
            growthAnalysisColumnsLtmIncDec.totalVolumeGrowth,
        ])
    },
    [tableViewNames.incDecGrowthAnalysisYtd]: {
        getOfficeOptions: () => ([
            growthAnalysisColumnsYtdIncDec.officeId,
            growthAnalysisColumnsYtdIncDec.officeAddress
        ]),
        getUnitOptions: () => ([
            growthAnalysisColumnsYtdIncDec.previousPeriodTotalUnits,
            growthAnalysisColumnsYtdIncDec.totalUnits,
            growthAnalysisColumnsYtdIncDec.totalUnitsChange,
            growthAnalysisColumnsYtdIncDec.totalUnitsGrowth
        ]),
        getVolumeOptions: () => ([
            growthAnalysisColumnsYtdIncDec.previousPeriodTotalVolume,
            growthAnalysisColumnsYtdIncDec.totalVolume,
            growthAnalysisColumnsYtdIncDec.totalVolumeChange,
            growthAnalysisColumnsYtdIncDec.totalVolumeGrowth,
        ]),
    },
    [tableViewNames.activity]: {
        currentTimeOptions: [
            activityColumns.officeName,
            activityColumns.activity,
            activityColumns.side,
            activityColumns.date
        ],
        allMlsTransactions: [
            activityColumns.listVolume,
            activityColumns.sellVolume,
            activityColumns.totalVolume
        ]
    },
};
